import { useI18n } from '@ggs/i18n'
import { getViewedPageParams } from '@ggs/utils'
import { syncFormToQueryString } from '../../../local/utils'

import './EmptyResult.scss'

/**
 * @return {JSX.Element}
 */
const EmptyResult = () => {
  const { t } = useI18n()
  const queryStringValues = getViewedPageParams({
    searchDistance: '50'
  })
  const canSearchAgain = parseInt(queryStringValues.searchDistance) < 200

  const searchAgain = () => {
    syncFormToQueryString({
      searchDistance: '200'
    })
    window.location.reload()
  }

  return (
    <article className="empty-result">
      <div className="empty-result__header">
        <h2 className="empty-result__title">
          {t('Sorry, we can\'t seem to find what you\'re looking for.')}
        </h2>
      </div>
      <div className="empty-result__content">
        <p>{t('Don\'t give up though! Here are a few things you can try:')}</p>
        <ul>
          {canSearchAgain && <li><button onClick={searchAgain}>{t('Click here to search again with an increased search distance')}</button></li>}
          <li>{t('Try another keyword')}</li>
          <li>{t('Try searching by disability or program categories')}</li>
          <li>{t('Visit our Help page')}</li>
        </ul>
      </div>
    </article>
  )
}

export default EmptyResult
